import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {PAGELIST_ID} from '@jobseeker/common-core/constants';
import PayuForm from './PayuForm';
import {handleTracking, getKeyFromPath, getUbaSource} from '@jobseeker/common-core/utils';
import router from 'next/router';
import {useEffect, useState} from 'react';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';
import {useSelector} from 'react-redux';
import {AppState} from '@jobseeker/common-core/types';
import {TrackEventUBA} from '@jobseeker/common-core/utils/analytics';
import {Image} from '@jobseeker/lotus/components/Image';
import {PaidProducts} from '../../constant';

const FailureComponent = () => {
  const theme = useWrappedTheme();
  const [transactionDetails, setTransactionDetails] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [paymentData, setPaymentData] = useState('');
  
  const profile = useSelector((state: AppState) => state.user.profile);
  const showRecruiterActions = profile?.proMembershipFeatures?.statusChange || false;

  useEffect(() => {
    const storedData = sessionStorage.getItem('paymentData');
    console.log('pay', storedData);
    
    if (storedData) {
      setPaymentData(JSON.parse(storedData));
    }
  }, []);

  const ProButton = () => (
    <Box>
      {' '}
      {/* Remove any additional bottom margin */}
      <PayuForm
        key={'pro_membership_plan_button'}
        title={'Retry Payment'}
        refCode="30"
        pageId={PAGELIST_ID['jd']}
        tracking={{action: 'jsSCBanner_PayClick', category: 'UpgradeToPro'}}
        sx={{
          background: 'black',
          width: '180px',
          height: '40px',
          display: 'inline-flex',
          padding: theme.spacing(1, 3),
          justifyContent: 'center',
          alignItems: 'center',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          fontSize: theme.typography.pxToRem(16),
        }}
        product={getProductInfo()}
      />
      <Typography
        onClick={() => router.push('/jobfeed')}
        sx={{
          color: theme.palette.primary.main,
          fontSize: theme.typography.pxToRem(17),
          fontFamily: 'Poppins',
          fontWeight: '500',
          lineHeight: {xs: 0.5, md: 4},
          letterSpacing: 0.64,
          wordWrap: 'break-word',
          cursor: 'pointer',
          marginTop: {sm: '15px', md: -1, xs: 2},
          marginLeft: {md: 1},
        }}
      >
        My Jobfeed
        <Box
          component="span"
          sx={{
            marginLeft: '4px',
            color: 'black',
            fontSize: theme.typography.pxToRem(16),
            fontWeight: 'bold',
          }}
        >
          &gt;
        </Box>
      </Typography>
    </Box>
  );

  useEffect(() => {
    handleTracking('jsViewProPopUp', {
      event_category: 'UpgradeToPro',
      UserId: sessionStorage.getItem('userId') || 'NA',
      Device: sessionStorage.getItem('device') || 'desktop',
      Device_Type: sessionStorage.getItem('deviceType') || 'web',
      Status: sessionStorage.getItem('status') || 'LoggedOut',
    });

    const ubaSource = getUbaSource(router?.query);

    TrackEventUBA('proMembershipPageClick', 'click', {
      ref: getKeyFromPath('ref') || '',
      page: window.location.pathname,
      source: ubaSource,
      clickType: 'Cancel',
    });
  }, []);

  const failureMessages = {
    jobseeker_pre_sub_200: 'Pro Membership Plan',
    [`${process.env.NEXT_PUBLIC_APP_NAME}-EA`]: 'Early Applicant',
    [`${process.env.NEXT_PUBLIC_APP_NAME}-RB`]: 'Resume Builder',
    [`${process.env.NEXT_PUBLIC_APP_NAME}-EA_RB`]:
      'Early Applicant and Resume Builder',
  };

  const getFailureMessage = () =>
    failureMessages[paymentData] || 'Transaction failed';

  const productInfoMap = {
    jobseeker_pre_sub_200: PaidProducts.PRO_MEMBERSHIP,
    [`${process.env.NEXT_PUBLIC_APP_NAME}-EA`]: PaidProducts.EARLY_APPLICANT,
    [`${process.env.NEXT_PUBLIC_APP_NAME}-RB`]: PaidProducts.RESUME_BUILDER,
    [`${process.env.NEXT_PUBLIC_APP_NAME}-EA_RB`]: '2,3',
  };

  const getProductInfo = () => productInfoMap[paymentData] || 0;
  console.log('paymentData', paymentData);
  

  return (
    <Box
      sx={{
        backgroundColor: 'border.main',
        minHeight: '891px',
        display: 'flex',
        alignItems: 'start',
        justifyContent: 'center',
        paddingTop: {xs: 0, md: 0.8},
      }}
    >
      <Box
        sx={{
          maxWidth: 1048,
          width: 1048,
          height: {xs: '482px', md: '450px'},
          padding: theme.spacing(6, 4),
          backgroundColor: 'primary.contrastText',
          borderRadius: 4,
          boxShadow: '0px 6.48px 6px 2px rgba(41, 41, 41, 0.04)',
          textAlign: 'center',
          marginBottom: 40,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: {sm: '-50px', md: '10px'},
        }}
      >
        <Box
          sx={{display: 'flex', justifyContent: 'center', marginBottom: '16px'}}
        >
          <Image
            src="data:image/jpeg;base64,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"
            width={36}
            height={36}
            alt="Failure Icon"
          />
        </Box>
        <Typography
          sx={{
            fontSize: {
              xs: theme.typography.pxToRem(16),
              md: theme.typography.pxToRem(18),
            },
            fontWeight: 600,
            lineHeight: {xs: '18px', md: '30px'},
            color: 'text.primary',
            marginBottom: 1,
          }}
        >
          {process.env.NEXT_PUBLIC_APP_DOMAIN} {getFailureMessage()} -
          Transaction failed
        </Typography>

        <Typography
          sx={{
            fontSize: {
              xs: theme.typography.pxToRem(14),
              md: theme.typography.pxToRem(16),
            },
            fontWeight: 500,
            lineHeight: '125%',
            color: 'text.primary',
            marginBottom: 2,
            maxWidth: 647,
          }}
        >
          Your payment towards the{' '}
          <b>
            {process.env.NEXT_PUBLIC_APP_DOMAIN} {getFailureMessage()}
          </b>{' '}
          was unsuccessful and hence the transaction was not processed by our
          payment partner.
        </Typography>

        <Typography
          sx={{
            fontSize: theme.typography.pxToRem(14),
            fontWeight: 600,
            lineHeight: {xs: '18px', md: '20px'},
            color: 'text.primary',
            marginBottom: 0.375,
          }}
        >
          Please retry the payment using a different payment method
        </Typography>

        <ProButton />
      </Box>
    </Box>
  );
};

export default FailureComponent;
